module.exports = __webpack_public_path__ + "img/ic_12_distance_white.10e267d4.svg";